export const isImage = (url?: string) => {
  if (url) {
    return /\.(jpg|jpeg|png|webp|avif|gif|svg)$/.test(url)
  }

  return false
}
